export enum RunningUploadStatus {
  Pending = 'Pending',
  Uploading = 'Uploading',
  Processing = 'Processing',
  Failed = 'Failed',
  Done = 'Done',
}
